import { render } from "./AddLeads.vue?vue&type=template&id=6e62d58c&scoped=true"
import script from "./AddLeads.vue?vue&type=script&lang=js"
export * from "./AddLeads.vue?vue&type=script&lang=js"

import "./AddLeads.vue?vue&type=style&index=0&id=6e62d58c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e62d58c"]])

export default __exports__